exports.VERIFICATION_FAIL = 'VERIFICATION_FAIL';
exports.VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS';
exports.SESSION_START = 'SESSION_START';
exports.LOGIN = 'LOGIN';
exports.LOGOUT = 'LOGOUT';
exports.ARTICLE_CART_ADD = 'ARTICLE_CARD_ADD';
exports.ARTICLE_CART_DELETE = 'ARTICLE_CARD_DELETE';
exports.UVP_TOGGLE = 'UVP_TOGGLE';
exports.PRICE_TOGGLE = 'PRICE_TOGGLE';
exports.CHECKOUT = 'CHECKOUT';
exports.ROUTE_VIEW = 'ROUTE_VIEW';

exports.ARTICLE_DETAIL_CLICK = 'ARTICLE_DETAIL_CLICK';
exports.FILTER_ARTICLES = 'FILTER_ARTICLES';



// WEBPACK FOOTER //
// ../shared/analytics_types/src/track.js